export var WCIOptions = {
    DataZoom: [
        {
            type: "inside",
            xAxisIndex: [0],
            start: 0,
            end: 100,
        },
        {
            show: true,
            xAxisIndex: [0],
            type: "slider",
            top: "96%",
            start: 0,
            end: 100,
        },
    ],
    Legend: [
        {
            data: [
                "WCI广告",
                "WCI外链",
                "WCI直播",
                "WCI公众号",
                "WCI搜一搜",
                "WCI问一问",
                "WCI视频号",
            ],
            type: "scroll",
            orient: "vertical",
            left: 10,
            top: 20,
            bottom: 20,
        }
    ],
    Grid: [{
        left: 200,
        right: 0,
        top: 50,
        height: "90%",
    }],
    xAxis: [{
        type: "category",
        boundaryGap: false,
        data: [],
    }],
    yAxis: [{
        type: "value",
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    }],
}


export var WCITKOptions = {
    DataZoom: [
        {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 0,
            end: 100,
        },
        {
            show: true,
            xAxisIndex: [0, 1],
            type: "slider",
            top: "96%",
            start: 0,
            end: 100,
        },
    ],
    Legend: [
        {
            data: [
                "WCI广告",
                "WCI外链",
                "WCI直播",
                "WCI公众号",
                "WCI搜一搜",
                "WCI问一问",
                "WCI视频号",
            ],
            type: "scroll",
            orient: "vertical",
            left: 10,
            top: 20,
            bottom: 20,
        },
        {
            data: [
                "TK搜索",
                "TK综合"
            ],
            gridIndex: 1,
            type: "scroll",
            orient: "vertical",
            left: 10,
            top: "54%",
            bottom: 20,
        }
    ],
    Grid: [{
        left: 200,
        right: "10%",
        top: 50,
        height: "40%",
    },
    {
        left: 200,
        right: "10%",
        top: "50%",
        height: "40%",
    }],
    xAxis: [{
        type: "category",
        boundaryGap: false,
        data: [],
    },
    {
        type: "category",
        gridIndex: 1,
        boundaryGap: false,
        data: [],
    }],
    yAxis: [{
        type: "value",
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    },
    {
        type: "value",
        gridIndex: 1,
        axisLabel: {
            formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                    return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                    return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                    return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
            },
        },
    }]
}